import React from 'react';
import PropTypes from 'prop-types';
import { Select, message, Modal, Button, Alert } from 'antd';
import CelaneseAPI from '../../services';
import './deleteobsolete.css';
import { connect } from 'react-redux';
import { getFiltersData, getCarbonFiltersData, getCigaretteData, getCarbonCigaretteData, getEpdData, getPlugwrapData } from './../../actions/index';
import config, { utils } from '../../config';
import Translation from '../../Translation';

const Option = Select.Option;
/**
 *
 * class is for deleting the obsolete designs
 * 
 * @class DeleteObsolete 
 * @extends {React.Component}
 */
class DeleteObsolete extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            apiDataForEpd: [],
            apiDataForFilter: [],
            apiDataForCigarette: [],
            apiDataForPlugwrap: [],
            apiDataForCarbonCigarette: [],
            apiDataForCarbonFilter: [],
            idPlugwrap: [],
            idEpd: [],
            plugwrapValue: [],
            epdValue: [],
            filterValuesArr: [],
            cigaretteValuesArr: [],
            carbonFilterValuesArr: [],
            carbonCigaretteValuesArr: [],
            filterObj: {},
            cigaretteObj: {},
            carbonFilterObj: {},
            carbonCigaretteObj: {},
            delLoading: false
        }
    }

    componentWillReceiveProps(nextProps) {
        this.assignData(nextProps);
    }

    componentWillMount() {
        this.assignData(this.props);
    }
    /**
     * assignData is getting the data from redux/store
     *
     * @memberof DeleteObsolete
     */
    assignData = (nextProps) => {
        if (nextProps.filtersData) {
            this.setState({
                apiDataForFilter: nextProps.filtersData
            })
        }
        if (nextProps.carbonFiltersData) {
            this.setState({
                apiDataForCarbonFilter: nextProps.carbonFiltersData
            })
        }
        if (nextProps.cigaretteData) {
            this.setState({
                apiDataForCigarette: nextProps.cigaretteData
            })
        }
        if (nextProps.carbonCigaretteData) {
            this.setState({
                apiDataForCarbonCigarette: nextProps.carbonCigaretteData
            })
        }
        if (nextProps.plugwrapData) {
            let apiDataForPlugwrap = nextProps.plugwrapData.reduce((a, b) => {
                if (b.isOwn) {
                    return a.concat(b);
                } else {
                    return a;
                }

            }, []);
            this.setState({
                apiDataForPlugwrap: apiDataForPlugwrap
            })
        }
        if (nextProps.epdData) {
            let apiDataForEpd = nextProps.epdData.reduce((a, b) => {
                if (b.isOwn) {
                    return a.concat(b);
                } else {
                    return a;
                }

            }, []);
            this.setState({
                apiDataForEpd: apiDataForEpd
            })
        }
    }
    /**
     * handleplugwrapchange filters the plugwrap selected from the select dropdown and filters it 
     * from the database and pushes it into an array
     *
     * @param {String} value contains the name of the plugwrap to be filtered
     * @memberof DeleteObsolete
     */
    handlePlugwrapChange = (value) => {
        let plugwrapData = this.state.apiDataForPlugwrap;
        let plugwrapResult = plugwrapData.filter(element => value.includes(element.name));
        var plugwrapIdArr = [];

        for (let i = 0; i < plugwrapResult.length; i++) {
            plugwrapIdArr.push(plugwrapResult[i].id);
        }
        this.setState({
            idPlugwrap: plugwrapIdArr,
            plugwrapValue: value
        });
    }
    /**
     * handleEpdChange filters the epd selected from the select dropdown and filters it 
     * from the database and pushes it into an array
     *
     * @param {String} value contains the name of the epd to be filtered
     * @memberof DeleteObsolete
     */
    handleEpdChange = (value) => {
        let epdData = this.state.apiDataForEpd;
        let epdResult = epdData.filter(element => value.includes(element.name));
        var epdIdArr = [];

        for (let i = 0; i < epdResult.length; i++) {
            epdIdArr.push(epdResult[i].id);
        }

        this.setState({
            idEpd: epdIdArr,
            epdValue: value
        });
    }
    /**
     * handleFilterChange filters the filter selected from the select dropdown and filters it 
     * from the database and pushes it into an array
     *
     * @param {String} value contains the name of the filter to be filtered
     * @memberof DeleteObsolete
     */
    handleFilterChange = (value) => {
        let filterData = this.state.apiDataForFilter;
        let filterResult = filterData.filter(element => value.includes(element.name + '' + element.displayName));
        let filterName = [];

        if (!this.objIsEmpty(filterResult) && filterResult instanceof Object) {
            filterResult.forEach(function (element) {
                filterName.push(element.name + '' + element.displayName);
            })
        }

        this.setState({
            filterValuesArr: filterName,
            filterObj: filterResult
        });
    }
    /**
     * handleCigaretteChange filters the cigarette selected from the select dropdown and filters it 
     * from the database and pushes it into an array
     *
     * @param {String} value contains the name of the cigarette to be filtered
     * @memberof DeleteObsolete
     */
    handleCigaretteChange = (value) => {
        let cigaretteData = this.state.apiDataForCigarette;
        let cigaretteResult = cigaretteData.filter(element => value.includes(element.name + '' + element.displayName));
        let cigaretteName = [];

        if (!this.objIsEmpty(cigaretteResult) && cigaretteResult instanceof Object) {
            cigaretteResult.forEach(function (element) {
                cigaretteName.push(element.name + '' + element.displayName);
            })
        }

        this.setState({
            cigaretteValuesArr: cigaretteName,
            cigaretteObj: cigaretteResult
        });
    }
    /**
     *
     * handleCarbonFilterChange filters the carbon filter selected from the select dropdown and filters it 
     * from the database and pushes it into an array
     * 
     * @param {String} value contains the name of the carbon filter to be filtered
     * @memberof DeleteObsolete
     */
    handleCarbonFilterChange = (value) => {
        let carbonFilterData = this.state.apiDataForCarbonFilter;
        let carbonFilterResult = carbonFilterData.filter(element => value.includes(element.dualFilterName + '' + element.displayName));

        let carbonFilterName = [];

        if (!this.objIsEmpty(carbonFilterResult) && carbonFilterResult instanceof Object) {
            carbonFilterResult.forEach(function (element) {
                carbonFilterName.push(element.dualFilterName + '' + element.displayName);
            })
        }

        this.setState({
            carbonFilterValuesArr: carbonFilterName,
            carbonFilterObj: carbonFilterResult
        });
    }
    /**
     * handleCarbonCigaretteChange filters the carbon cigarette selected from the select dropdown and filters it 
     * from the database and pushes it into an array
     * 
     * @param {String} value contains the name of the carbon cigarette to be filtered
     * @memberof DeleteObsolete
     */
    handleCarbonCigaretteChange = (value) => {
        let carbonCigaretteData = this.state.apiDataForCarbonCigarette;
        let carbonCigaretteResult = carbonCigaretteData.filter(element => value.includes(element.name + '' + element.displayName));
        let carbonCigaretteName = [];

        if (!this.objIsEmpty(carbonCigaretteResult) && carbonCigaretteResult instanceof Object) {
            carbonCigaretteResult.forEach(function (element) {
                carbonCigaretteName.push(element.name + '' + element.displayName);
            })
        }
        this.setState({
            carbonCigaretteValuesArr: carbonCigaretteName,
            carbonCigaretteObj: carbonCigaretteResult
        });
    }

    /**
     * objIsEmpty checks if the object is empty 
     * 
     * @param {Object} obj 
     * @memberof DeleteObsolete
     */
    objIsEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }
    /**
     * delete function deletes all the selected plugwrap, epd, filters and cigarettes
     *
     * @memberof DeleteObsolete
     */
    delete = () => {
        var promiseArray = [];
        let idPlugwraps = this.state.idPlugwrap;
        var deletePlugwrapPromises = [];
        this.setState({ delLoading: true });
        if (idPlugwraps && idPlugwraps instanceof Array) {
            idPlugwraps.forEach(function(idToDelete) {
                deletePlugwrapPromises.push(CelaneseAPI.delete(config.API.plugwrapId.replace(':id', idToDelete)));
            });

            Promise.all(deletePlugwrapPromises).then(() => {
                getPlugwrapData().then(res => {
                    return res;
                });
            });
            promiseArray = promiseArray.concat(deletePlugwrapPromises);
        }

        let idEpds = this.state.idEpd;
        var deleteEpdPromises = [];
        if (idEpds && idEpds instanceof Array) {
            idEpds.forEach(function (idToDelete) {
                deleteEpdPromises.push(CelaneseAPI.delete(config.API.epdBiasById.replace(':id', idToDelete)));
            });

            Promise.all(deleteEpdPromises).then(() => {
                getEpdData().then(res => {
                    return res;
                });
            });
            promiseArray = promiseArray.concat(deleteEpdPromises);
        }

        let filterObj = this.state.filterObj;
        var deleteFilterPromises = [];

        if (!this.objIsEmpty(filterObj) && filterObj instanceof Object) {
            filterObj.forEach(function (element) {
                var idToDelete = element.id;
                deleteFilterPromises.push(CelaneseAPI.delete(config.API.filtersByName.replace(':id', idToDelete)));
            })
            Promise.all(deleteFilterPromises).then(() => {
                getFiltersData().then(res => {
                    return res;
                });
            });

            promiseArray = promiseArray.concat(deleteFilterPromises);
        }

        let cigaretteObj = this.state.cigaretteObj;
        var deleteCigarettePromises = [];

        if (!this.objIsEmpty(cigaretteObj) && cigaretteObj instanceof Object) {
            cigaretteObj.forEach(function (element) {
                var idToDelete = element.id;
                deleteCigarettePromises.push(CelaneseAPI.delete(config.API.cigaretteById.replace(':id', idToDelete)));
            })
            Promise.all(deleteCigarettePromises).then(() => {
                getCigaretteData().then(res => {
                    return res;
                });
            });

            promiseArray = promiseArray.concat(deleteCigarettePromises);
        }

        let carbonFilterObj = this.state.carbonFilterObj;
        var deleteCarbonFilterPromises = [];

        if (!this.objIsEmpty(carbonFilterObj) && carbonFilterObj instanceof Object) {
            carbonFilterObj.forEach(function (element) {
                var idToDelete = element.id;
                deleteCarbonFilterPromises.push(CelaneseAPI.delete(config.API.carbonFiltersByName.replace(':id', idToDelete)));
            })
            Promise.all(deleteCarbonFilterPromises).then(() => {
                getCarbonFiltersData().then(res => {
                    return res;
                });
            });

            promiseArray = promiseArray.concat(deleteCarbonFilterPromises);
        }

        let carbonCigaretteObj = this.state.carbonCigaretteObj;
        var deleteCarbonCigarettePromises = [];

        if (!this.objIsEmpty(carbonCigaretteObj) && carbonCigaretteObj instanceof Object) {
            carbonCigaretteObj.forEach(function (element) {
                var idToDelete = element.id;
                deleteCarbonCigarettePromises.push(CelaneseAPI.delete(config.API.carbonCigaretteById.replace(':id', idToDelete)));
            })
            Promise.all(deleteCarbonCigarettePromises).then(() => {
                getCarbonCigaretteData().then(res => {
                    return res;
                });
            });
        }

        if (!idPlugwraps.length
            && !idEpds.length
            && this.objIsEmpty(filterObj)
            && this.objIsEmpty(cigaretteObj)
            && this.objIsEmpty(carbonFilterObj)
            && this.objIsEmpty(carbonCigaretteObj)) {
            this.warning();
        }
        else {
            Promise.all(promiseArray).then(() => {
                this.success();
                this.handleClear();
                this.setState({ delLoading: false });
            })
        }
    }
    /**
     * handleClear clears all the fields and restore the default values
     *
     * @memberof DeleteObsolete
     */
    handleClear = () => {
        this.setState({
            plugwrapValue: [],
            epdValue: [],
            filterValuesArr: [],
            cigaretteValuesArr: [],
            carbonFilterValuesArr: [],
            carbonCigaretteValuesArr: [],
            idPlugwrap: [],
            idEpd: [],
            filterObj: {},
            cigaretteObj: {},
            carbonFilterObj: {},
            carbonCigaretteObj: {}
        });
    }
    /**
     * handleCancel closess the delete obsolete window
     *
     * @memberof DeleteObsolete
     */
    handleCancel = () => {
        this.props.showDeleteObsoleteScreen(false);
    }

    /**
     *success function is for showing success message when data is deleted successfully
     *
     * @memberof DeleteObsolete
     */
    success = () => {
        message.success(
            utils.getTranslationText('msg_data_sucess_deleted', 'Data successfully deleted.'), 2);
    }
    /**
     *error function is for showing error message when data is not deleted
     *
     * @memberof DeleteObsolete
     */
    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }
    /**
     *warning function is for showing warning message when nothing is selected to delete
     *
     * @memberof DeleteObsolete
     */
    warning = () => {
        message.warning(utils.getTranslationText('msg_plz_atleast_one_option_to_delete', 'Please select atleast one option to delete'), 2);
    }


    render() {
        const childrenPlugwrap = [];
        const data = this.state.apiDataForPlugwrap ? this.state.apiDataForPlugwrap : [];
        for (let i = 0; i < data.length; i++) {
            childrenPlugwrap.push(<Option key={i} value={data[i].name}>{data[i].name}</Option>);
        }

        const childrenEpd = [];
        const epdData = this.state.apiDataForEpd ? this.state.apiDataForEpd : [];
        for (let i = 0; i < epdData.length; i++) {
            childrenEpd.push(<Option key={i} value={epdData[i].name}>{epdData[i].name}</Option>);
        }

        const childrenCigarette = [];
        const cigaretteData = this.state.apiDataForCigarette ? this.state.apiDataForCigarette : [];
        for (let i = 0; i < cigaretteData.length; i++) {
            childrenCigarette.push(<Option key={i} value={cigaretteData[i].name + '' + cigaretteData[i].displayName}>{cigaretteData[i].name + '' + cigaretteData[i].displayName}</Option>);
        }

        const childrenFilter = [];
        const filterData = this.state.apiDataForFilter ? this.state.apiDataForFilter : [];
        for (let i = 0; i < filterData.length; i++) {
            childrenFilter.push(<Option key={i} value={filterData[i].name + '' + filterData[i].displayName}>{filterData[i].name + '' + filterData[i].displayName}</Option>);
        }

        const childrenCarbonCigarette = [];
        const carbonCigaretteData = this.state.apiDataForCarbonCigarette ? this.state.apiDataForCarbonCigarette : [];
        for (let i = 0; i < carbonCigaretteData.length; i++) {
            childrenCarbonCigarette.push(<Option key={i} value={carbonCigaretteData[i].name + '' + carbonCigaretteData[i].displayName}>{carbonCigaretteData[i].name + '' + carbonCigaretteData[i].displayName}</Option>);
        }

        const childrenCarbonFliter = [];
        const carbonFilterData = this.state.apiDataForCarbonFilter ? this.state.apiDataForCarbonFilter : [];
        for (let i = 0; i < carbonFilterData.length; i++) {
            childrenCarbonFliter.push(<Option key={i} value={carbonFilterData[i].dualFilterName + '' + carbonFilterData[i].displayName}>{carbonFilterData[i].dualFilterName + '' + carbonFilterData[i].displayName}</Option>);
        }

        return (
            <div>
                <Modal
                title={<Translation labelName="title_tools_delete_obsolete" defaultText="Delete Obsolete Designs"/>}
                    visible={this.props.isDeleteObsoleteVisible}
                    footer={null}
                    width="40%"
                    centered
                    style={{ top: 20 }}
                    onCancel={() => this.handleCancel()}>
                    <div className="delete-wrapper row">
                        {/* <a href='/help/html/Delete_Obsolete_Designs.htm' title="Help" target="_blank" className="help-section">
                            <img
                                src="./images/help-inverse-black.svg"
                                alt="help"
                                className="help-icon" />
                        </a> */}
                        <div className='col-md-12 m1-bottom'>
                        <Alert message={<Translation labelName="msg_delete_warning" defaultText="You'll be able to delete only the items you created"/>} type="warning" showIcon />
                        </div>
                        <div className="col-md-12 delete-row-wrapper">
                            <div className="filter-section col-md-6 delete-obsolete-select">
                                <label><Translation labelName="lbl_filter_design" defaultText="Filter Designs"/></label>
                                <Select
                                    mode="multiple"
                                    value={this.state.filterValuesArr}
                                    onChange={this.handleFilterChange}>
                                    {childrenFilter}
                                </Select>
                            </div>
                            <div className="cigarette-section col-md-6 delete-obsolete-select">
                                <label><Translation labelName="lbl_cigarette_design" defaultText="Cigarette Designs"/></label>
                                <Select
                                    mode="multiple"
                                    value={this.state.cigaretteValuesArr}
                                    onChange={this.handleCigaretteChange}>
                                    {childrenCigarette}
                                </Select>
                            </div>
                        </div>
                        <div className="col-md-12 delete-row-wrapper">
                            <div className='carbon-filter-section col-md-6 delete-obsolete-select'>
                                <label><Translation labelName="lbl_dual_filter_design" defaultText="Dual Filter Designs"/></label>
                                <Select
                                    mode="multiple"
                                    value={this.state.carbonFilterValuesArr}
                                    onChange={this.handleCarbonFilterChange}>
                                    {childrenCarbonFliter}
                                </Select>
                            </div>
                            <div className='carbon-cigarette-section col-md-6 delete-obsolete-select'>
                                <label><Translation labelName="lbl_dual_cigarette" defaultText="Dual Cigarette Designs"/></label>
                                <Select
                                    mode="multiple"
                                    value={this.state.carbonCigaretteValuesArr}
                                    onChange={this.handleCarbonCigaretteChange}>
                                    {childrenCarbonCigarette}
                                </Select>
                            </div>
                        </div>
                        <div className="col-md-12 delete-row-wrapper">
                            <div className="filter-design col-md-6 delete-obsolete-select">
                                <label><Translation labelName="lbl_plugwrap_delete_obsolete " defaultText="Plugwrap Designs"/></label>
                                <Select
                                    mode="multiple"
                                    onChange={this.handlePlugwrapChange}
                                    value={this.state.plugwrapValue}>
                                    {childrenPlugwrap}
                                </Select>
                            </div>
                            <div className="epd-section col-md-6 delete-obsolete-select">
                                <label><Translation labelName="lbl_epd_bias" defaultText="EPD Bias"/></label>
                                <Select
                                    mode="multiple"
                                    value={this.state.epdValue}
                                    onChange={this.handleEpdChange}>
                                    {childrenEpd}
                                </Select>
                            </div>
                        </div>
                        <div className="delete-btn-wrapper">
                            <Button type="primary" loading={this.state.delLoading} className='btn btn-primary delete-btn' onClick={this.delete}><Translation labelName="btn_delete" defaultText="Delete"/></Button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = ({ loggedUserState, filtersState }) => ({
    prefData: loggedUserState.prefData,
    filtersData: filtersState.filtersData,
    carbonFiltersData: filtersState.carbonFiltersData,
    cigaretteData: filtersState.cigaretteData,
    carbonCigaretteData: filtersState.carbonCigaretteData,
    plugwrapData: filtersState.plugwrapData,
    epdData: filtersState.epdData
});

export default connect(mapStateToProps, null)(DeleteObsolete);

DeleteObsolete.propTypes = {
    showDeleteObsoleteScreen: PropTypes.func,
    isDeleteObsoleteVisible: PropTypes.bool,
    prefData: PropTypes.object,
    getFiltersData: PropTypes.func,
    filtersData: PropTypes.array,
    getCarbonFiltersData: PropTypes.func,
    carbonFiltersData: PropTypes.array,
    getCigaretteData: PropTypes.func,
    cigaretteData: PropTypes.any,
    getCarbonCigaretteData: PropTypes.func,
    carbonCigaretteData: PropTypes.any,
    getPlugwrapData: PropTypes.func,
    plugwrapData: PropTypes.any,
    getEpdData: PropTypes.func,
    epdData: PropTypes.any
};


// WEBPACK FOOTER //
// ./src/components/DeleteObsolete/index.js